<template>
  <div>
    <div class="background">
    </div>
    <div class="content">
      <span @click="$router.back(-1)" class="header_back mr10"><i class="el-icon-back header_return"></i></span>{{$route.query.student_name}}
      <div class="mt20 ml20 " v-for="(item, index) in studentPaperDetailModel.list" :key="item.index">
        <div class="fl">{{index + 1}}、</div>
        <question :render-data="item"></question>
        <el-button class="mt10" size="mini" type="primary" @click="teacherScore(item)">评分</el-button>
      </div>
      <p class="mt20 ml20">总分：{{ratingScore}}</p>
      <p class="mt10 ml20">评级：{{theRating}}</p>
      <p class="mt10 ml20">评语：</p>
      <el-input class="mt10 ml20 comments_input fl" v-model="comment" placeholder="请输入评语" clearable></el-input>
      <el-button class="mt60 fr mr20 mb20" type="primary" @click="finishedComment">完成</el-button>
    </div>

    <el-dialog title="评分" :visible.sync="teacherScoreVisible" width="400px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="60px" class="demo-ruleForm">
        <el-form-item label="评分" prop="score">
          <el-input v-model="ruleForm.score"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="teacherScoreVisible = false">取 消</el-button>
    <el-button type="primary" @click="submitTeacherScore(ruleForm)">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex';
  import {
    map,
    reduce,
    parseInt
  } from 'lodash'
  export default {
    data() {
      return {
        comment: '',
        teacherScoreVisible: false,
        ruleForm: {
          score: '',
        },
        rules: {
          score: [
            {
              validator: function (rule, value, callback) {
                if (/^([1-9][\d]{0,7}|0)(\.[\d]{1,2})?$/.test(value) == false) {
                  callback(new Error("只能输入数字"));
                } else {
                  callback();
                }
              }, trigger: 'blur'
            },
            {required: true, message: '请输入评分', trigger: 'blur'},
          ]
        }
      }
    },
    computed: {
      ...mapGetters({
        'studentPaperDetailModel': 'getTeacherExerciseStudentPaperDetailModel',//教师批改学生试卷试题列表
      }),
      ratingScore() {
        let result = '';
        let array= [];
        array = map(this.studentPaperDetailModel.list, function (item) {
          return{
            score: item.paper_has_question ? item.paper_has_question.score : 0
          }
        });
        result = reduce(array, function (last, item) {
          return last + parseFloat(item.score)
        },0);
        return result
      },
      theRating() {
        if (this.ratingScore > (this.studentPaperDetailModel.paper_total_score * (this.studentPaperDetailModel.pass_score / 100))) {
          return '及格'
        }else {
          return '不及格'
        }
      }
    },
    methods: {
      ...mapActions({
        'exerciseStudentPaperDetailModel': 'actionTeacherExerciseStudentPaperDetailModel',//教师批改学生试卷试题列表
        'teacherHomeWorkStudentMarkScoreModel': 'actionTeacherHomeWorkStudentMarkScoreModel',//评分
        'teacherStudentExamPaperCommentModel': 'actionTeacherStudentExamPaperCommentModel',//评语
      }),
      teacherScore(item) {
        this.teacherScoreVisible = true;
        this.ruleForm.score = item.paper_has_question ? item.paper_has_question.score : 0;
        this.ruleForm.paper_id = this.$route.query.paper_id;
        this.ruleForm.student_id = this.$route.query.student_id;
        this.ruleForm.id = item.paper_has_question ? item.paper_has_question.id : '';
        this.ruleForm.total_score = item.score;
      },
      submitTeacherScore(query) {
        if(parseInt(query.score) > parseInt(query.total_score)) {
          this.$message('评分不可大于本题分数');
        }else {
          this.$refs['ruleForm'].validate((val) => {
            if(val) {
              this.teacherHomeWorkStudentMarkScoreModel({
                question_id: query.id,
                score: query.score
              }).then(() => {
                this.teacherScoreVisible = false;
                this.$message.success('评分成功');
                this.getList()
              })
            }
          })
        }
      },
      finishedComment() {
        if(this.comment){
          this.teacherStudentExamPaperCommentModel({
            comment: this.comment,
            student_paper_id: this.studentPaperDetailModel.student_has_exam_paper_id
          }).then(() => {
            this.$router.back(-1)
          })
        }else {
          this.$router.back(-1)
        }
      },
      getList() {
        let query = this.$route.query;
        this.exerciseStudentPaperDetailModel({
          page: 1,
          size: 999,
          student_paper_id: query.student_has_exam_paper_id,
          student_id: query.student_id,
        }).then((result) => {
          this.comment = result.comment
        })
      }
    },
    created() {
      this.getList()
    }
  }

</script>

<style scoped>
  .background {
    width: 100%;
    height: 40px;
    background-color: #f5f8fa;
  }
  .content {
    padding: 20px;
  }
  .header_back {
    display: inline-block;
    cursor: pointer;
    width: 25px;
    height: 25px;
    background-color: black;
    border-radius: 50%;
    position: relative;
    top: 8px;
  }
  .header_return {
    position: absolute;
    left: 5px;
    top: 5px;
    color: white;
  }
  .comments_input{
    width: 80%;
  }
</style>
